// <pos-staff-mgr/> — 員工管理（owner only，W1 佔位）
// see architecture.md#L280 auth, staff_invitations

class PosStaffMgr extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.render();
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
        :host { display: block; padding: var(--s-5); }
        .placeholder { padding: var(--s-8); text-align: center; color: var(--fg-muted); }
      </style>
      <h2>員工帳號管理</h2>
      <div class="placeholder" data-testid="staff-placeholder">
        <p>這裡管理「<strong>登入帳號</strong>」：邀請員工開通 POS 登入、分派操作權限（店長／收銀／廚房）。<br/>邀請連結 / 角色分派 UI 規劃中（W13 與員工端一起上線）。</p>
        <p>要建立「<strong>排班用員工名單</strong>」（含不需登入系統的兼職）請到
          <a href="#/settings/scheduling" style="color: var(--brand-primary);">設定 → 排班</a>，
          排班員工之後可在這裡綁定登入帳號。</p>
      </div>
    `;
  }
}

customElements.define('pos-staff-mgr', PosStaffMgr);
